import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { filterPropertyTypes, } from '@debbie/common/dist/properties/index.js';
import PlaceholderLoader from '../PlaceholderLoader.js';
import Property from './Property.js';
import Well from '../Well.js';
import { ChevronDown, ChevronUp } from '../Icons/index.js';
import { usePropertyTypes } from '@debbie/cortex/dist/properties/index.js';
import { h } from '@debbie/cortex/dist/index.js';
const NewEntityProperties = (props) => {
    const lang = useSelector((s) => s.lang);
    const propertyTypesLoadable = usePropertyTypes();
    const propertyTypes = h.hasData(propertyTypesLoadable)
        ? filterPropertyTypes(propertyTypesLoadable.data, props.propRef, props.scope, props.scopeId)
        : null;
    const [collapsed, setCollapsed] = useState(false);
    const updateProperty = async (handle, ref, refId, data, type, setLoading, setDone) => {
        setLoading(true);
        props.onChange({ handle, data, type, ref });
        setLoading(false);
        setDone(true);
        setTimeout(() => {
            setDone(false);
        }, 1000);
    };
    return propertyTypes && propertyTypes.length > 0 ? (React.createElement(React.Fragment, null,
        React.createElement("div", { style: {
                cursor: 'pointer',
                marginBottom: '10px',
            }, onClick: () => setCollapsed(!collapsed) },
            React.createElement("b", null, lang.properties.properties),
            collapsed ? (React.createElement(ChevronDown, { size: 25, style: { float: 'right' } })) : (React.createElement(ChevronUp, { size: 25, style: { float: 'right' } }))),
        !collapsed && (React.createElement(Well, { style: { marginBottom: '20px' } },
            React.createElement(PropertiesStyled, null,
                h.isLoading(propertyTypesLoadable) && React.createElement(PlaceholderLoader, null),
                propertyTypes.map((propertyType) => (React.createElement(Property, { editable: true, key: propertyType.propertyTypeId, propertyType: propertyType, updateProperty: updateProperty, newEntity: true })))))))) : null;
};
export default NewEntityProperties;
const PropertiesStyled = styled.div `
  font-size: 0.75em;
  input,
  select {
    margin-bottom: 0px;
  }
`;
//# sourceMappingURL=NewEntityProperties.js.map